import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Card, Elevation, Tag } from '@blueprintjs/core';
import { DateTime } from 'luxon';
import numbro from 'numbro';

import Line from './line';

const fmtr = x => numbro(x.toFixed(2)).format('0,0');

const RamChart = ({ data }) => {
  const time = data.columns.findIndex(x => x === 'time');
  const labels = data.values.map(x => DateTime.fromMillis(x[time]).toFormat('ff'));
  const available = data.columns.findIndex(x => x === 'mean_ram_available');
  const total = data.columns.findIndex(x => x === 'mean_ram_total');
  const color = '#D0B5F5';

  const datasets = [
    {
      label: 'RAM',
      data: data.values.map(x => ((x[total] - x[available]) / x[total]) * 100),
      fill: true,
      pointRadius: 0,
      lineTension: 0,
      borderWidth: 1.5,
      borderColor: color,
      spanGaps: false,
      suffix: '%',
    },
  ];

  const chartDataset = { datasets, labels };

  return (
    <Fragment>
      <Tag large>RAM Utilization</Tag>
      <Card elevation={Elevation.THREE} style={{ marginTop: 10 }}>
        <div style={{ minHeight: 500 }}>
          <Line
            data={() => chartDataset}
            legend
            yFmtr={fmtr}
            position="bottom"
            yLabel=""
          />
        </div>
      </Card>
    </Fragment>
  );
};

RamChart.propTypes = {
  data: PropTypes.object,
};

export default RamChart;
